/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { APIOPERATIONINFO } from '../model/aPIOPERATIONINFO';
import { AUDITTRAILINFO } from '../model/aUDITTRAILINFO';
import { CARDINFO } from '../model/cARDINFO';
import { POLLERCONFIGURATIONINFO } from '../model/pOLLERCONFIGURATIONINFO';
import { POLLERCONFIGURATIONUPDATEENTITY } from '../model/pOLLERCONFIGURATIONUPDATEENTITY';
import { SMSRDESTINATIONADDRESSOBJECT } from '../model/sMSRDESTINATIONADDRESSOBJECT';
import { SMSRHTTPADDRESSOBJECT } from '../model/sMSRHTTPADDRESSOBJECT';
import { SUBSCRIPTIONINFO } from '../model/sUBSCRIPTIONINFO';
import { TRANSACTIONINFO } from '../model/tRANSACTIONINFO';
import { UPDATECONNECTIVITYOBJECT } from '../model/uPDATECONNECTIVITYOBJECT';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CardsService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Get list of available audit trail records for the card.
     * @param eid EID of a requested card
     * @param offset offset within last events
     * @param limit maximum number of entries to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidAuditGet(eid: string, offset?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AUDITTRAILINFO>>;
    public cardsEidAuditGet(eid: string, offset?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AUDITTRAILINFO>>>;
    public cardsEidAuditGet(eid: string, offset?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AUDITTRAILINFO>>>;
    public cardsEidAuditGet(eid: string, offset?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidAuditGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<AUDITTRAILINFO>>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/audit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Number of available audit trail records for the card
     * @param eid EID of a requested card
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidAuditHead(eid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidAuditHead(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidAuditHead(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidAuditHead(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidAuditHead.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.head<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/audit`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Request online card audit operation.  The reuqest will be sent to the following receivers * MSISDN of currently ENABLED profile * MSISDN of a last profile that was active during Enable operation (Rollback case) * MSISDN of a profile with fallback attribute (Fallback case)   **GSMA interfaces endpoint(s):** &gt;*ES4.AuditEIS* 
     * @param eid EID of a requested card
     * @param enqueue if set, and eUICC supports operation polling mechanism, the request will be enqueued
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidAuditPost(eid: string, enqueue?: boolean, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidAuditPost(eid: string, enqueue?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidAuditPost(eid: string, enqueue?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidAuditPost(eid: string, enqueue?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidAuditPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enqueue !== undefined) {
            queryParameters = queryParameters.set('enqueue', <any>enqueue);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/audit`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get detailed information on the operation related to particular audit trail record
     * @param eid EID of a requested card
     * @param recordId Record identifier within the euicc audit trail
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidAuditRecordIdGet(eid: string, recordId: number, observe?: 'body', reportProgress?: boolean): Observable<APIOPERATIONINFO>;
    public cardsEidAuditRecordIdGet(eid: string, recordId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APIOPERATIONINFO>>;
    public cardsEidAuditRecordIdGet(eid: string, recordId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APIOPERATIONINFO>>;
    public cardsEidAuditRecordIdGet(eid: string, recordId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidAuditRecordIdGet.');
        }
        if (recordId === null || recordId === undefined) {
            throw new Error('Required parameter recordId was null or undefined when calling cardsEidAuditRecordIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<APIOPERATIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/audit/${encodeURIComponent(String(recordId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get a profile with the fallback attribute
     * @param eid EID of the requested card
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidFallbackGet(eid: string, observe?: 'body', reportProgress?: boolean): Observable<SUBSCRIPTIONINFO>;
    public cardsEidFallbackGet(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SUBSCRIPTIONINFO>>;
    public cardsEidFallbackGet(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SUBSCRIPTIONINFO>>;
    public cardsEidFallbackGet(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidFallbackGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<SUBSCRIPTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/fallback`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Set fallback attribute operation  **GSMA Interfaces endpoint(s):** &gt;*ES5.SetFallbackAttribute*
     * @param eid EID of the requested card
     * @param iccid ICCID of the target profile
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidFallbackPost(eid: string, iccid: string, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidFallbackPost(eid: string, iccid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidFallbackPost(eid: string, iccid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidFallbackPost(eid: string, iccid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidFallbackPost.');
        }
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling cardsEidFallbackPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (iccid !== undefined) {
            queryParameters = queryParameters.set('iccid', <any>iccid);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/fallback`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a card from the database
     * @param eidOrIccid EID or ICCID of a requested card
     * @param poolReturnProfileFlag Profiles returns into pool, if flag is true
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidOrIccidDelete(eidOrIccid: string, poolReturnProfileFlag?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidOrIccidDelete(eidOrIccid: string, poolReturnProfileFlag?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidOrIccidDelete(eidOrIccid: string, poolReturnProfileFlag?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidOrIccidDelete(eidOrIccid: string, poolReturnProfileFlag?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eidOrIccid === null || eidOrIccid === undefined) {
            throw new Error('Required parameter eidOrIccid was null or undefined when calling cardsEidOrIccidDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (poolReturnProfileFlag !== undefined) {
            queryParameters = queryParameters.set('poolReturnProfileFlag', <any>poolReturnProfileFlag);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/cards/${encodeURIComponent(String(eidOrIccid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get detailed information about the card  **GSMA interfaces Endpoint(s):** &gt;*ES4.GetEIS*
     * @param eidOrIccid EID or ICCID of a requested card
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidOrIccidGet(eidOrIccid: string, observe?: 'body', reportProgress?: boolean): Observable<CARDINFO>;
    public cardsEidOrIccidGet(eidOrIccid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CARDINFO>>;
    public cardsEidOrIccidGet(eidOrIccid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CARDINFO>>;
    public cardsEidOrIccidGet(eidOrIccid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eidOrIccid === null || eidOrIccid === undefined) {
            throw new Error('Required parameter eidOrIccid was null or undefined when calling cardsEidOrIccidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<CARDINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eidOrIccid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Returns current configuration for specified poller on the specified card
     * @param eid EID of the card, for which poller configuration will be returned
     * @param pollerType Type of poller for which poller configuration will be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidPollerGet(eid: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<POLLERCONFIGURATIONINFO>;
    public cardsEidPollerGet(eid: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POLLERCONFIGURATIONINFO>>;
    public cardsEidPollerGet(eid: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POLLERCONFIGURATIONINFO>>;
    public cardsEidPollerGet(eid: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidPollerGet.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardsEidPollerGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<POLLERCONFIGURATIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/poller/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete poller configuration updates.
     * @param eid EID of the card, for which poller configuration updates will be deleted
     * @param pollerType Type of poller for which configuration updates will be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidPollerUpdatesDelete(eid: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidPollerUpdatesDelete(eid: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidPollerUpdatesDelete(eid: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidPollerUpdatesDelete(eid: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidPollerUpdatesDelete.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardsEidPollerUpdatesDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/poller/updates`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Returns scheduled updates for specified poller on the specified card. If there is no scheduled updates, empty POLLER_CONFIGURATION_UPDATE_ENTITY will be returned.
     * @param eid EID of the card, for which poller configuration updates will be returned
     * @param pollerType Type of poller for which poller configuration updates will be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidPollerUpdatesGet(eid: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<POLLERCONFIGURATIONUPDATEENTITY>;
    public cardsEidPollerUpdatesGet(eid: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POLLERCONFIGURATIONUPDATEENTITY>>;
    public cardsEidPollerUpdatesGet(eid: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POLLERCONFIGURATIONUPDATEENTITY>>;
    public cardsEidPollerUpdatesGet(eid: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidPollerUpdatesGet.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardsEidPollerUpdatesGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<POLLERCONFIGURATIONUPDATEENTITY>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/poller/updates`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update poller configuration.
     * @param eid EID of the card, for which poller configuration will be updated
     * @param pollerType Type of poller for which configuration will be updated
     * @param updateEntity Card poller configuration updates. All fields of update_entity are optional. If some field is not specified, it will not be updated.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidPollerUpdatesPost(eid: string, pollerType: string, updateEntity: POLLERCONFIGURATIONUPDATEENTITY, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidPollerUpdatesPost(eid: string, pollerType: string, updateEntity: POLLERCONFIGURATIONUPDATEENTITY, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidPollerUpdatesPost(eid: string, pollerType: string, updateEntity: POLLERCONFIGURATIONUPDATEENTITY, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidPollerUpdatesPost(eid: string, pollerType: string, updateEntity: POLLERCONFIGURATIONUPDATEENTITY, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidPollerUpdatesPost.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardsEidPollerUpdatesPost.');
        }
        if (updateEntity === null || updateEntity === undefined) {
            throw new Error('Required parameter updateEntity was null or undefined when calling cardsEidPollerUpdatesPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/poller/updates`,
            updateEntity,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a profile from the card. After this operation is successful system triggers an audit on the card.  **GSMA interfaces endpoint(s):** &gt;*ES2.DeleteProfile* 
     * @param eid EID of a requested card
     * @param iccid ICCID of a target profile
     * @param enqueue if set, and eUICC supports operation polling mechanism, the request will be enqueued
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidProfilesDelete(eid: string, iccid: string, enqueue?: boolean, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidProfilesDelete(eid: string, iccid: string, enqueue?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidProfilesDelete(eid: string, iccid: string, enqueue?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidProfilesDelete(eid: string, iccid: string, enqueue?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesDelete.');
        }
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (iccid !== undefined) {
            queryParameters = queryParameters.set('iccid', <any>iccid);
        }
        if (enqueue !== undefined) {
            queryParameters = queryParameters.set('enqueue', <any>enqueue);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get a list of profiles available on the card
     * @param eid EID of a requested card
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidProfilesGet(eid: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SUBSCRIPTIONINFO>>;
    public cardsEidProfilesGet(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SUBSCRIPTIONINFO>>>;
    public cardsEidProfilesGet(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SUBSCRIPTIONINFO>>>;
    public cardsEidProfilesGet(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<SUBSCRIPTIONINFO>>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * &lt;font color&#x3D;red&gt;&lt;b&gt;Deprecated&lt;/b&gt;&lt;/font&gt;, please use &lt;b&gt;POST /cards/{eid}/audit&lt;/b&gt; instead.
     * @param eid EID of the requested card
     * @param iccid ICCID of the requested card
     * @param enqueue if set, and eUICC supports operation polling mechanism, the request will be enqueued
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidProfilesIccidAuditPost(eid: string, iccid: string, enqueue?: boolean, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidProfilesIccidAuditPost(eid: string, iccid: string, enqueue?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidProfilesIccidAuditPost(eid: string, iccid: string, enqueue?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidProfilesIccidAuditPost(eid: string, iccid: string, enqueue?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesIccidAuditPost.');
        }
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesIccidAuditPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enqueue !== undefined) {
            queryParameters = queryParameters.set('enqueue', <any>enqueue);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles/${encodeURIComponent(String(iccid))}/audit`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update connectivity parameters for given ICCID; will return transaction id to check status of operation.  **GSMA Interfaces endpoint(s):** &gt;*ES3.UpdateConnectivityParameters*
     * @param eid EID of the requested card
     * @param iccid ICCID of the requested card
     * @param connectivityObject Connectivity configuration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidProfilesIccidConnectivityPost(eid: string, iccid: string, connectivityObject: UPDATECONNECTIVITYOBJECT, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidProfilesIccidConnectivityPost(eid: string, iccid: string, connectivityObject: UPDATECONNECTIVITYOBJECT, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidProfilesIccidConnectivityPost(eid: string, iccid: string, connectivityObject: UPDATECONNECTIVITYOBJECT, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidProfilesIccidConnectivityPost(eid: string, iccid: string, connectivityObject: UPDATECONNECTIVITYOBJECT, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesIccidConnectivityPost.');
        }
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesIccidConnectivityPost.');
        }
        if (connectivityObject === null || connectivityObject === undefined) {
            throw new Error('Required parameter connectivityObject was null or undefined when calling cardsEidProfilesIccidConnectivityPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles/${encodeURIComponent(String(iccid))}/connectivity`,
            connectivityObject,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update SM-SR destination address for given ICCID; will return transaction id to check status of operation
     * @param eid EID of the requested card
     * @param iccid ICCID of the requested card
     * @param smsrAddressObject SM-SR address configuration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidProfilesIccidSmsrDestinationAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRDESTINATIONADDRESSOBJECT, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidProfilesIccidSmsrDestinationAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRDESTINATIONADDRESSOBJECT, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidProfilesIccidSmsrDestinationAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRDESTINATIONADDRESSOBJECT, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidProfilesIccidSmsrDestinationAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRDESTINATIONADDRESSOBJECT, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesIccidSmsrDestinationAddressPost.');
        }
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesIccidSmsrDestinationAddressPost.');
        }
        if (smsrAddressObject === null || smsrAddressObject === undefined) {
            throw new Error('Required parameter smsrAddressObject was null or undefined when calling cardsEidProfilesIccidSmsrDestinationAddressPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles/${encodeURIComponent(String(iccid))}/smsr_destination_address`,
            smsrAddressObject,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update SM-SR HTTP address for given ICCID; will return transaction id to check status of operation
     * @param eid EID of the requested card
     * @param iccid ICCID of the requested card
     * @param smsrAddressObject SM-SR address configuration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidProfilesIccidSmsrHttpAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRHTTPADDRESSOBJECT, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidProfilesIccidSmsrHttpAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRHTTPADDRESSOBJECT, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidProfilesIccidSmsrHttpAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRHTTPADDRESSOBJECT, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidProfilesIccidSmsrHttpAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRHTTPADDRESSOBJECT, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesIccidSmsrHttpAddressPost.');
        }
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesIccidSmsrHttpAddressPost.');
        }
        if (smsrAddressObject === null || smsrAddressObject === undefined) {
            throw new Error('Required parameter smsrAddressObject was null or undefined when calling cardsEidProfilesIccidSmsrHttpAddressPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles/${encodeURIComponent(String(iccid))}/smsr_http_address`,
            smsrAddressObject,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Enable or disable the selected profile on the card  **GSMA interfaces endpoint(s):** &gt;*ES4.EnableProfile* &gt;*ES4.DisableProfile*
     * @param eid EID of the requested card
     * @param iccid ICCID of the target profile
     * @param enable true if the profile should be enabled, false if it should be disabled
     * @param enqueue if set, and eUICC supports operation polling mechanism, the request will be enqueued
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidProfilesPost(eid: string, iccid: string, enable: boolean, enqueue?: boolean, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidProfilesPost(eid: string, iccid: string, enable: boolean, enqueue?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidProfilesPost(eid: string, iccid: string, enable: boolean, enqueue?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidProfilesPost(eid: string, iccid: string, enable: boolean, enqueue?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesPost.');
        }
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesPost.');
        }
        if (enable === null || enable === undefined) {
            throw new Error('Required parameter enable was null or undefined when calling cardsEidProfilesPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (iccid !== undefined) {
            queryParameters = queryParameters.set('iccid', <any>iccid);
        }
        if (enable !== undefined) {
            queryParameters = queryParameters.set('enable', <any>enable);
        }
        if (enqueue !== undefined) {
            queryParameters = queryParameters.set('enqueue', <any>enqueue);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Download a profile to the card  **GSMA interfaces endpoint(s):** &gt;*ES2.DownloadProfile*
     * @param eid EID of a requested card
     * @param poolId profile pool to take a profile from
     * @param activate Set to true if the profile should be activated after download
     * @param iccid ICCID of the profile to select
     * @param enqueue if set, and eUICC supports operation polling mechanism, the request will be enqueued
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidProfilesPut(eid: string, poolId: string, activate?: boolean, iccid?: string, enqueue?: boolean, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidProfilesPut(eid: string, poolId: string, activate?: boolean, iccid?: string, enqueue?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidProfilesPut(eid: string, poolId: string, activate?: boolean, iccid?: string, enqueue?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidProfilesPut(eid: string, poolId: string, activate?: boolean, iccid?: string, enqueue?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesPut.');
        }
        if (poolId === null || poolId === undefined) {
            throw new Error('Required parameter poolId was null or undefined when calling cardsEidProfilesPut.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (poolId !== undefined) {
            queryParameters = queryParameters.set('pool_id', <any>poolId);
        }
        if (activate !== undefined) {
            queryParameters = queryParameters.set('activate', <any>activate);
        }
        if (iccid !== undefined) {
            queryParameters = queryParameters.set('iccid', <any>iccid);
        }
        if (enqueue !== undefined) {
            queryParameters = queryParameters.set('enqueue', <any>enqueue);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.put<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Cancel current queue for card. If &#39;includeCurrent&#39; flag &#x3D;&#x3D; true and there is running request in queue, retry_counter of the running request will be set to max_retry value, and all other requests will be cancelled.
     * @param eid EID of the card, for which queue will be canceled
     * @param includeCurrent Cancel retries for the active request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidQueueDelete(eid: string, includeCurrent: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidQueueDelete(eid: string, includeCurrent: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidQueueDelete(eid: string, includeCurrent: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidQueueDelete(eid: string, includeCurrent: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidQueueDelete.');
        }
        if (includeCurrent === null || includeCurrent === undefined) {
            throw new Error('Required parameter includeCurrent was null or undefined when calling cardsEidQueueDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeCurrent !== undefined) {
            queryParameters = queryParameters.set('include_current', <any>includeCurrent);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/queue/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Returns current queue of transactions for specified card
     * @param eid EID of the card, for which queue will be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidQueueGet(eid: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TRANSACTIONINFO>>;
    public cardsEidQueueGet(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TRANSACTIONINFO>>>;
    public cardsEidQueueGet(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TRANSACTIONINFO>>>;
    public cardsEidQueueGet(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidQueueGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<TRANSACTIONINFO>>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/queue/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update queue order. If size of queue order in request is smaller than size of current queue, new queue will have order as queue in request and requests, whose IDs were not mentioned in queue order, will be canceled.
     * @param eid EID of the card, for which queue order will be updated
     * @param order New order of transactions specified as a list of transaction_ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidQueuePost(eid: string, order?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidQueuePost(eid: string, order?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidQueuePost(eid: string, order?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidQueuePost(eid: string, order?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidQueuePost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (order) {
            order.forEach((element) => {
                queryParameters = queryParameters.append('order', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.post<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/queue/`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get detailed information on the last operation with the card
     * @param eid EID of a requested card
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidStatusGet(eid: string, observe?: 'body', reportProgress?: boolean): Observable<APIOPERATIONINFO>;
    public cardsEidStatusGet(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APIOPERATIONINFO>>;
    public cardsEidStatusGet(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APIOPERATIONINFO>>;
    public cardsEidStatusGet(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidStatusGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<APIOPERATIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/status`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get information about list of transactions or single transaction. Sorted by started date-time.
     * @param eid EID of the requested card
     * @param transactionId ID of the requested transaction
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidTransactionsGet(eid: string, transactionId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TRANSACTIONINFO>>;
    public cardsEidTransactionsGet(eid: string, transactionId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TRANSACTIONINFO>>>;
    public cardsEidTransactionsGet(eid: string, transactionId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TRANSACTIONINFO>>>;
    public cardsEidTransactionsGet(eid: string, transactionId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidTransactionsGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (transactionId !== undefined) {
            queryParameters = queryParameters.set('transaction_id', <any>transactionId);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<TRANSACTIONINFO>>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/transactions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Cancel transaction for card.
     * @param eid EID of the card for which transaction will be cancelled
     * @param transactionId ID of the transaction that will be cancelled
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidTransactionsTransactionIdDelete(eid: string, transactionId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidTransactionsTransactionIdDelete(eid: string, transactionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidTransactionsTransactionIdDelete(eid: string, transactionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidTransactionsTransactionIdDelete(eid: string, transactionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidTransactionsTransactionIdDelete.');
        }
        if (transactionId === null || transactionId === undefined) {
            throw new Error('Required parameter transactionId was null or undefined when calling cardsEidTransactionsTransactionIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/transactions/${encodeURIComponent(String(transactionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Transaction state getting operation
     * @param eid EID of the requested card
     * @param transactionId ID of the requested transaction
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidTransactionsTransactionIdGet(eid: string, transactionId: string, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public cardsEidTransactionsTransactionIdGet(eid: string, transactionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public cardsEidTransactionsTransactionIdGet(eid: string, transactionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public cardsEidTransactionsTransactionIdGet(eid: string, transactionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidTransactionsTransactionIdGet.');
        }
        if (transactionId === null || transactionId === undefined) {
            throw new Error('Required parameter transactionId was null or undefined when calling cardsEidTransactionsTransactionIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/transactions/${encodeURIComponent(String(transactionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Card list getting operation. This is the operation to get a list of cards managed by the authenticated account.
     * @param offset An offset for a list (required for pagination)
     * @param limit A maximum number of entries returned by the request
     * @param searchString Search for cards with given EID, ICCID, MSISDN or IMEI
     * @param cardGroupId Filter records by present group Id
     * @param poolId Filter records by present pool Id
     * @param mnoId Filter records by present mno Id
     * @param numberOfSubscriptions Filter records by the number of subscriptions present
     * @param status Filter record by status of the card
     * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - eid,  - imsi,  - iccid,  - msisdn,  - mno_id,  - group_id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CARDINFO>>;
    public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CARDINFO>>>;
    public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CARDINFO>>>;
    public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (searchString !== undefined) {
            queryParameters = queryParameters.set('search_string', <any>searchString);
        }
        if (cardGroupId) {
            cardGroupId.forEach((element) => {
                queryParameters = queryParameters.append('card_group_id', <any>element);
            })
        }
        if (poolId) {
            poolId.forEach((element) => {
                queryParameters = queryParameters.append('pool_id', <any>element);
            })
        }
        if (mnoId) {
            mnoId.forEach((element) => {
                queryParameters = queryParameters.append('mno_id', <any>element);
            })
        }
        if (numberOfSubscriptions) {
            numberOfSubscriptions.forEach((element) => {
                queryParameters = queryParameters.append('number_of_subscriptions', <any>element);
            })
        }
        if (status) {
            status.forEach((element) => {
                queryParameters = queryParameters.append('status', <any>element);
            })
        }
        if (sortString !== undefined) {
            queryParameters = queryParameters.set('sort_string', <any>sortString);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<CARDINFO>>(`${this.basePath}/cards`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Number of cards getting operation. This is the operation to get a number of cards managed by the authenticated account
     * @param searchString Search for cards with given EID, ICCID, MSISDN or IMEI
     * @param cardGroupId Filter records by present group Id
     * @param poolId Filter records by present pool Id
     * @param mnoId Filter records by present mno Id
     * @param numberOfSubscriptions Filter records by the number of subscriptions present
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsHead(searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsHead(searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsHead(searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsHead(searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (searchString !== undefined) {
            queryParameters = queryParameters.set('search_string', <any>searchString);
        }
        if (cardGroupId) {
            cardGroupId.forEach((element) => {
                queryParameters = queryParameters.append('card_group_id', <any>element);
            })
        }
        if (poolId) {
            poolId.forEach((element) => {
                queryParameters = queryParameters.append('pool_id', <any>element);
            })
        }
        if (mnoId) {
            mnoId.forEach((element) => {
                queryParameters = queryParameters.append('mno_id', <any>element);
            })
        }
        if (numberOfSubscriptions) {
            numberOfSubscriptions.forEach((element) => {
                queryParameters = queryParameters.append('number_of_subscriptions', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.head<any>(`${this.basePath}/cards`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api/cards.service.ts